import logEvent from 'analytics/logEvent';
import cn from 'classnames';
import useTranslationAndTypograph from 'hooks/useTranslationAndTypograph';
import React, { useState } from 'react';

import Button from 'components/basic/Button';
import Checkbox from 'components/basic/Checkbox';
import { Caption } from 'components/basic/Typography';

import s from './CookieSettings.module.scss';

interface Props {
  onClose: () => void;
}

export default function CookieSettings({ onClose }: Props): JSX.Element {
  const t = useTranslationAndTypograph();
  const [checked, setChecked] = useState(true);

  return (
    <div className={s.textWrapper}>
      <Caption className={s.text}>
        {t(
          'Is it ok if we use cookies to make this site easy and safe for you? We respect your privacy,',
        )}{' '}
        <a
          href="https://welltory.com/cookie/"
          className={s.link}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('here is how.')}
        </a>
      </Caption>
      <Caption className={cn(s.text, s.secondText)}>
        {t(
          'Necessary cookies allow you to move around the site and use its features. They can’t be turned off.',
        )}
      </Caption>
      <div className={s.checkedTextWrapper}>
        <Caption className={s.thirdText}>
          {t(
            'Optional cookies allow us remember your choices and give you better functionality — you can turn them off if you wish',
          )}
        </Caption>
        <Checkbox
          className={s.checkbox}
          id="cookie"
          name="cookie"
          onChange={(value): void => {
            logEvent('Web_Cookie_Checkbox_Button_Clicked', {
              cookie_accepted: value,
            });
            setChecked(value);
          }}
          checked={checked}
        />
      </div>
      <div className={s.buttonWrapper}>
        <Button size="small" look="secondary" onClick={onClose}>
          {t('accept')}
        </Button>
      </div>
    </div>
  );
}
